import React, { useState } from "react";
import Layout from "../Layout";
import * as RB from "react-bootstrap";
import * as utils from "../Utils/comman";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MyTeamCounter from "../Components/Counter/MyTeamCounter";
import View from "../Components/Counter/CounterWiseGraphView";
import MainCounter from "./MainCounter";

function ListCounter() {
  const navigate = useNavigate();
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [compo, setCompo] = useState("list");
  const [key, setKey] = useState("myCounter");

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Counter Summaries</h1>
          </div>
          <div className="section-body">
            <RB.Card className="card shadow">
              <RB.Card.Header>
                <div className="floating-btns-holder-artisan"></div>
              </RB.Card.Header>
              <RB.Card.Body>
                <>
                  {utils.hasPermission(
                    primaryMenuRes,
                    "Counter",
                    "counter.viewAll"
                  ) ? (
                    <MainCounter />
                  ) : (
                    <>
                      <RB.Tabs
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        id="counter-tabs"
                        className="mb-3"
                      >
                        {utils.hasPermission(
                          primaryMenuRes,
                          "Counter",
                          "my_counter.counter"
                        ) && (
                          <RB.Tab
                            eventKey="myCounter"
                            title="My Counter"
                          ></RB.Tab>
                        )}
                        {utils.hasPermission(
                          primaryMenuRes,
                          "Counter",
                          "team_counter.counter"
                        ) && (
                          <RB.Tab
                            eventKey="teamCounter"
                            title="Team Counter"
                          ></RB.Tab>
                        )}
                      </RB.Tabs>
                      {key === "myCounter" && (
                        <div>
                          <MyTeamCounter tabKey={key} setCompo={setCompo} />
                        </div>
                      )}
                      {key === "teamCounter" && (
                        <div>
                          <MyTeamCounter tabKey={key} setCompo={setCompo} />
                        </div>
                      )}
                    </>
                  )}
                </>
              </RB.Card.Body>
            </RB.Card>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default ListCounter;
